module.exports = __webpack_public_path__ + "img/logo-mini.9e73f976.svg";